<script lang="ts" setup>
import type { NewsItem } from "~/composables/use-news";

const { $config } = useNuxtApp()

const props =  defineProps<{
  item: NewsItem,
}>()

const imagePath = computed<string>(() => `${$config.public.API_URL}/images/${props.item?.id}/${props.item?.id}.jpeg`);
</script>

<template>
  <div class="bg-white pt-20 pr-40 pl-40 pb-40 text-left cursor-pointer w-full min-h-[28.563rem] h-full">
    <figure class="mb-30">
      <nuxt-link :to="`nyheter/${item.slug}`">
        <NuxtImg class="h-auto lg:max-w-[25rem] overflow-hidden" alt="Sälj din el" loading="lazy" :src="imagePath" />
      </nuxt-link>
    </figure>
    <div>
      <nuxt-link :to="`nyheter/${item.slug}`" class="text-xl text-25 font-semibold pb-16 mb-10 md:mb-20 block border-b-2 border-cyan leading-normal">
        {{ item.heading }}
      </nuxt-link>
      <nuxt-link :to="`nyheter/${item.slug}`" class="transition hover:text-cyan-400">
        <p class="font-semibold text-right">Läs mer</p>
      </nuxt-link>
    </div>
  </div>
</template>
<style>

</style>
